import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { namespaces, useSharedTranslation } from 'us-react-components/dist/hooks/useSharedTranslation';

import { Button, ButtonSize, ButtonType } from '../../components';
import { MembershipPayment } from './MembershipPayment';
import { PayoutFaq } from './PayoutFaq';

export const BranchDeactivated = (): JSX.Element => {
  const { t } = useSharedTranslation(namespaces.caregiver);

  return (
    <article className='py-6'>
      <div className='w-full'>
        <div className='flex flex-col md:flex-row'>
          <div className='md:w-1/2'>
            <h1 className='text-2xl font-semibold'>{t('pages.sitter.payout.title')}</h1>
            <div className='mb-10 border-2 rounded-2xl p-3'>
              <div className='mb-2.5 font-bold'>{t('pages.sitter.payout.active.title')}</div>
              <div className='mb-2.5'>
                {t('pages.sitter.payout.deactivated.body1Branch')}
              </div>
              <div className='mb-2.5'>
                {t('pages.sitter.payout.deactivated.body2Branch')}
              </div>
              <Button
                className='block my-5'
                buttonType={ButtonType.primary}
                buttonSize={ButtonSize.large}
                onClick={(): void => {
                  window.open('https://support.branchapp.com/hc/en-us/articles/360056795671-How-do-I-contact-Branch-Support#:~:text=Give%20us%20a,00%20PM%20CST', '_blank', 'noreferrer');
                }}
              >
                {t('pages.sitter.payout.deactivated.reactivate')}
              </Button>
              <div className='text-gray'>
                <FontAwesomeIcon icon={faLock} className='mr-2' />{t('pages.sitter.payout.securedBranch')}
              </div>
            </div>
            <div className='md:hidden mb-10 md:p-14 md:w-1/2'>
              <PayoutFaq />
            </div>
            <MembershipPayment />
          </div>
          <div className='hidden md:block mb-10 md:p-14 md:w-1/2'>
            <PayoutFaq />
          </div>
        </div>
      </div>
    </article>
  );
};
